import type { CatalogContentBlock, UseAndCareBlock } from "@/domain/catalog";
import type { UseAndCareGuide } from "@/composites/product";

export function resolveUseAndCareGuide(
	contentBlocks: CatalogContentBlock[] | undefined
): UseAndCareGuide | undefined {
	const block = (contentBlocks ?? []).find(
		(b): b is UseAndCareBlock => b.blockType === "use_and_care_block"
	);
	if (!block?.title) return undefined;
	return {
		title: block.title,
		eyebrowText: block.eyebrow_text,
		bodyHtml: block.body
	};
}
